var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rednax-datatable',{attrs:{"columns":_vm.table_columns,"url":"/vue/activitylog","filter":{ subject_type: this.type, subject_id: this.id },"sort-by":"created_at","sort-order":"created_at"},scopedSlots:_vm._u([{key:"cell_properties",fn:function(ref){
var row = ref.row;
return [_vm._v("\n        "+_vm._s(_vm.parseChanges(row))+"\n    ")]}},{key:"cell_causer_id",fn:function(ref){
var row = ref.row;
return [_vm._v("\n        "+_vm._s(row.causer ? row.causer.name : '')+"\n    ")]}},{key:"cell_entity",fn:function(ref){
var row = ref.row;
return [_vm._v("\n        "+_vm._s(_vm.getEntity(row))+"\n    ")]}},{key:"cell_created_at",fn:function(ref){
var row = ref.row;
return [_vm._v("\n        "+_vm._s(_vm.formatDateTime(row.created_at))+"\n    ")]}}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }